import React from 'react';
import Main from '../../layout/Main';
import FaqMainContent from './FaqMainContent';

function FaqIndex() {
  return (
    <Main main={<FaqMainContent />} contentLeft={null} contentRight={null} />
  );
}

export default FaqIndex;
